module.exports = __webpack_public_path__ + "img/product_group_4_img.1de92f49.png";